// eslint-disable-next-line import/prefer-default-export
export const asyncLoadingStates = Object.freeze({ // asyn loading states for components
  awaiting: 1,
  loading: 2,
  loaded: 3,
  error: 4,
});
